<zbp-zbchart-report-table
  [reportLabel]="'shared-student-over-time-report-label' | translate"
  [showProgressReportsHelp]="showProgressReportsHelp"
  [leftHeaderText]="'shared-student-over-time-report-column-test' | translate"
  [rightHeaderText]="'shared-student-over-time-report-column-student-scores-and-status' | translate"
  [zbChart]="zbChart"
  [printableReportHeadings]="printableReportHeadings"
  [isPrinting]="isPrinting"
/>
